import { createApp } from 'vue'
import FProductCard from '~/js/components/productCard'
import FButtonCopy from '~/js/components/buttonCopy'
import { getItemsFromIds } from '~/js/helpers/getProducts'
import { numberWithCommas } from '~/js/helpers'
import { ProductListService } from '~/js/services/productListService'

const ID_CUSTOMERS_ACCOUNT_PRODUCTLIST = 'js-customersAccountProductlist'

document.addEventListener('DOMContentLoaded', async () => {
  const elementCustomersAccountProductlist = document.getElementById(
    ID_CUSTOMERS_ACCOUNT_PRODUCTLIST
  )
  if (!elementCustomersAccountProductlist) return

  const productListService = new ProductListService()
  const { hasError, wishlists } = await productListService.getWishLists()

  const selectedIndex = 0
  const ids = wishlists.length ? wishlists[selectedIndex].productIds : []
  const productsInSelectedList = await getItemsFromIds(ids)
  createApp({
    name: 'TemplatesCustomersAccountWishlist',
    components: { FButtonCopy, FProductCard },
    data() {
      return {
        hasError,
        isProcessing: false,
        wishlists,
        productsInSelectedList,
        selectedIndex,
      }
    },
    computed: {
      totalPrice() {
        const totalPrice = this.productsInSelectedList.reduce(
          (total, product) => total + product.price,
          0
        )
        return numberWithCommas(totalPrice)
      },
      urlShare() {
        return `${window.location.origin}/pages/wishlist?id=${
          this.wishlists[this.selectedIndex].id
        }`
      },
    },
    watch: {
      async selectedIndex() {
        const ids = this.wishlists[this.selectedIndex].productIds
        this.productsInSelectedList = await getItemsFromIds(ids)
      },
    },
    methods: {
      isInWishlist(product) {
        return this.wishlists[this.selectedIndex].productIds.includes(
          product.id
        )
      },
      onProductAddedToList(id) {
        this.wishlists[this.selectedIndex].productIds.push(id)
      },
      onProductRemovedFromList(id) {
        const index = this.wishlists[this.selectedIndex].productIds.findIndex(
          (productId) => productId === id
        )
        this.wishlists[this.selectedIndex].productIds.splice(index, 1)
      },
      async retry() {
        this.hasError = false
        this.isProcessing = true
        const { hasError, wishlists } = await productListService.getWislists()
        this.hasError = hasError
        this.wishlists = wishlists
        this.isProcessing = false
      },
    },
  }).mount(elementCustomersAccountProductlist)
})
